import { cn } from '../../../../tw-utils/src/cn.js';
import { CommandItem } from '../../lib/command.jsx';
import { typographyVariants } from '../../lib/typography.jsx';

function ComboboxItem({
  className,
  selected,
  ...props
}: React.ComponentProps<typeof CommandItem> & {
  selected?: boolean;
}) {
  return (
    <CommandItem
      aria-label="combobox-item"
      data-state={selected ? 'checked' : 'unchecked'}
      className={cn(
        typographyVariants({
          variant: 'bodyShort01',
        }),
        'grid h-10 min-w-fit cursor-pointer grid-cols-[auto_1fr] items-center gap-2 px-3 py-1.5 text-ellipsis whitespace-nowrap text-text-primary *:cursor-pointer',
        // selected state styles
        'has-data-[state=checked]:bg-background-tertiary data-[state=checked]:bg-background-tertiary data-[state=checked]:fill-tertiary-main data-[state=checked]:text-tertiary-main',
        //hover state styles
        'hover:bg-ui-hover has-data-[state=checked]:hover:bg-ui-highlight data-[state=checked]:hover:bg-ui-highlight',
        //disabled state styles
        'aria-disabled:text-action-disabled01 aria-disabled:hover:bg-ui-primary',

        className,
      )}
      {...props}
    />
  );
}

export default ComboboxItem;
